import React from "react";
import { ProfileContext, updateCache } from "./ProfileContext";
import { useContext } from "react";
import "./profiles.css";
// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import SelectInput from "../../common/SelectInput";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Android12Switch } from "../../common/Swtich";
import MultiselectInputChipbox from "../../common/MultiselectInputChipbox";
import PhoneNumberInput from "../../common/PhoneNumberInput";
import {
  motherTongueOptions,
  languageOptions,
  casteOptions,
  nakshatraOptions,
  kuldevataOptions,
  gotraOptions,
  rashiHindiOptions,
  bloodGroupOptions,
  drinkingHabitsOptions,
  smokingHabitsOptions,
  mathOptions
} from "./../../constants/profileData";

function OptionalDetails({ optionalDetailsVisited, setOptionalDetailsVisited }) {
    const {
        motherTongue,
        setMotherTongue,
        motherTongueError,
        nakshatra,
        setNakshatra,
        nakshatraError,
        kuldevta,
        setKuldevta,
        kuldevtaError,
        gotra,
        setGotra,
        gotraError,
        rashi,
        setRashi,
        rashiError,
        caste,
        setCaste,
        casteError,
        languagesKnown,
        setLanguagesKnown,
        languagesKnownError,
        isNRI,
        setIsNRI,
        bloodGroup,
        setBloodGroup,
        bloodGroupError,
        drinkHabits,
        setDrinkHabits,
        drinkHabitsError,
        smokeHabits,
        setSmokeHabits,
        smokeHabitsError,
        setComplexion,
        fatherName,
        setFatherName,
        fatherNameError,
        fatherNumber,
        setFatherNumber,
        fatherNumberError,
        motherName,
        setMotherName,
        fatherNumberCountry,
        setFatherNumberCountry,
        motherNumberCountry,
        setMotherNumberCountry,
        motherNameError,
        motherNumber,
        setMotherNumber,
        motherNumberError,
        bio,
        setBio,
        bioError,
        math,
        setMath,
        mathError,
        setCachedData
      } = useContext(ProfileContext);
    
  React.useEffect(() => {
    if (!optionalDetailsVisited) {
      window.scrollTo(0, 0); // Scroll to top only if not visited before
      setOptionalDetailsVisited(true); // Mark as visited
    }
  }, [optionalDetailsVisited, setOptionalDetailsVisited]);
  
  const handleChange = (event) => {
    const { name, value } = event.target;
        if(name !== "isNRI" && name !==  "languagesKnown")
          updateCache(name, value, setCachedData);
    switch (name) {
      case "isNRI":
        setIsNRI(event.target.checked);
        updateCache(name, event.target.checked, setCachedData);
        break;
      case "motherTongue":
        setMotherTongue(value);
        break;
      case "caste":
        setCaste(value);
        break;
      case "languagesKnown":
        var parsedValue = typeof value === "string" ? value.split(",") : value
        updateCache(name, parsedValue, setCachedData);
        setLanguagesKnown(parsedValue);
        break;
      case "nakshatra":
        setNakshatra(value);
        break;
      case "kuldevta":
        setKuldevta(value);
        break;
      case "gotra":
        setGotra(value);
        break;
      case "rashi":
        setRashi(value);
        break;
      case "bloodGroup":
        setBloodGroup(value);
        break;
      case "drinkHabits":
        setDrinkHabits(value);
        break;
      case "smokeHabits":
        setSmokeHabits(value);
        break;
      case "complexion":
        setComplexion(value);
        break;
      case "fatherName":
        setFatherName(value);
        break;
      case "fatherNumber":
        setFatherNumber(value);
        break;
      case "fatherNumberCountry":
        setFatherNumberCountry(value);
        break;
      case "motherName":
        setMotherName(value);
        break;
      case "motherNumber":
        setMotherNumber(value);
        break;
      case "motherNumberCountry":
        setMotherNumberCountry(value);
        break;
      case "bio":
        setBio(value);
        break;
      case "math":
        setMath(value);
        break;
      default:
        break;
    }
  };

  return (
    <div className="p-6 mx-auto">
      <center>
        <h3 className="font-bold text-2xl text-center mt-3">Optional Details</h3>
        <p className="font-regular text-md text-center text-gray-500">
          You can skip this field and fill these details later
        </p>
      </center>

      <Grid container spacing={4} className="mt-5">
      <Grid item xs={12}>
          <TextField
            label="Bio"
            fullWidth
            name="bio"
            multiline
            variant="outlined"
            value={bio}
            placeholder="Tell us about yourself"
            onChange={handleChange}
            error={bioError}
            helperText={bioError ? "Bio is required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography>Are you a NRI?</Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>No</Typography>
            <FormControlLabel
              control={
                <Android12Switch
                  name="isNRI"
                  checked={isNRI}
                  onChange={handleChange}
                />
              }
            />
            <Typography>Yes</Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="motherTongue"
            label="Mother Tongue"
            value={motherTongue}
            handleChange={handleChange}
            error={motherTongueError}
            helperText={motherTongueError ? "Mother Tongue is required" : ""}
            options={motherTongueOptions()}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="caste"
            label="Caste"
            value={caste}
            handleChange={handleChange}
            error={casteError}
            helperText={casteError ? "Caste is required" : ""}
            options={casteOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="nakshatra"
            label="Nakshatra"
            value={nakshatra}
            handleChange={handleChange}
            error={nakshatraError}
            helperText={nakshatraError ? "Nakshatra is required" : ""}
            options={nakshatraOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="kuldevta"
            label="Kuldevta"
            value={kuldevta}
            handleChange={handleChange}
            error={kuldevtaError}
            helperText={kuldevtaError ? "Kuldevta is required" : ""}
            options={kuldevataOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="gotra"
            label="Gotra"
            value={gotra}
            handleChange={handleChange}
            error={gotraError}
            helperText={gotraError ? "Gotra is required" : ""}
            options={gotraOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="rashi"
            label="Rashi"
            value={rashi}
            handleChange={handleChange}
            error={rashiError}
            helperText={rashiError ? "Rashi is required" : ""}
            options={rashiHindiOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="math"
            label="Math"
            value={math}
            handleChange={handleChange}
            error={mathError}
            helperText={mathError ? "Math is required" : ""}
            options={mathOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <MultiselectInputChipbox
            name="languagesKnown"
            label="Languages Known (multiselect)"
            value={languagesKnown}
            onChange={handleChange}
            error={languagesKnownError}
            helperText={
              languagesKnownError ? "Languages Known is required" : ""
            }
            fullWidth
            variant="outlined"
            placeholder="Enter your languages known"
            options={languageOptions}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="bloodGroup"
            label="Blood Group"
            value={bloodGroup}
            handleChange={handleChange}
            error={bloodGroupError}
            helperText={bloodGroupError ? "Blood Group is required" : ""}
            options={bloodGroupOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>

        {/* <Grid item xs={12} sm={6}>
          <SelectInput
            name="complexion"
            label="Complexion"
            value={complexion}
            handleChange={handleChange}
            error={complexionError}
            helperText={complexionError ? "Complexion is required" : ""}
            options={complexionOptions}
            fullWidth
            variant="outlined"
          />
        </Grid> */}

        <Grid item xs={12} sm={6}>
           <SelectInput
            name="drinkHabits"
            label="Drinking Habits"
            value={drinkHabits}
            handleChange={handleChange}
            error={drinkHabitsError}
            helperText={drinkHabitsError ? "Required field" : ""}
            options={drinkingHabitsOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SelectInput
            name="smokeHabits"
            label="Smoking Habits"
            value={smokeHabits}
            handleChange={handleChange}
            error={smokeHabitsError}
            helperText={smokeHabitsError ? "Required field" : ""}
            options={smokingHabitsOptions}
            fullWidth
            variant="outlined"
          />
        </Grid>
      </Grid>

      <Grid container spacing={4} className="mt-5">
        <Grid item xs={12} sm={6}>
          <TextField
            variant="outlined"
            label="Father Name"
            fullWidth
            name="fatherName"
            value={fatherName}
            placeholder="Enter your father's name"
            onChange={handleChange}
            error={fatherNameError}
            helperText={fatherNameError ? "Father's name is required" : ""}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <PhoneNumberInput
            contactNumber={fatherNumber}
            contactNumberCountry={fatherNumberCountry}
            handleChange={handleChange}
            contactNumberError={fatherNumberError}
            placeholder="Enter your father's number"
            label="Father Number"
            helperText={fatherNumberError ? "Father's Number is not valid" : ""}
            name="fatherNumber"
            countryCodeName="fatherNumberCountry"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            variant="outlined"
            label="Mother Name"
            fullWidth
            name="motherName"
            value={motherName}
            placeholder="Enter your mother's name"
            onChange={handleChange}
            error={motherNameError}
            helperText={motherNameError ? "Mother's name is required" : ""}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <PhoneNumberInput
            contactNumber={motherNumber}
            contactNumberCountry={motherNumberCountry}
            handleChange={handleChange}
            contactNumberError={motherNumberError}
            placeholder="Enter your mother's number"
            label="Mother Number"
            helperText={motherNumberError ? "Mother's Number is not valid" : ""}
            name="motherNumber"
            countryCodeName="motherNumberCountry"
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default OptionalDetails;
